/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.7842 14.7526c0-.9929.805-1.7978 1.7978-1.7978.9929 0 1.7978.8049 1.7978 1.7978 0 .9929-.8049 1.7978-1.7978 1.7978-.9929 0-1.7978-.8049-1.7978-1.7978Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 0c-.9665 0-1.75.7835-1.75 1.75v7.0945C.956 9.1775 0 10.3521 0 11.75V18c0 1.3979.956 2.5725 2.25 2.9055V22.25c0 .9665.7835 1.75 1.75 1.75h16c.9665 0 1.75-.7835 1.75-1.75v-1.3445C23.0439 20.5725 24 19.3979 24 18v-6.25c0-1.3979-.9561-2.5725-2.25-2.9055V1.75C21.75.7835 20.9665 0 20 0H4Zm-.25 22.25V21h16.5v1.25a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25Zm16.5-13.5v-7A.25.25 0 0 0 20 1.5H4a.25.25 0 0 0-.25.25v7h16.5Zm-9.668 2.85c-1.7411 0-3.1526 1.4115-3.1526 3.1526 0 1.7412 1.4115 3.1527 3.1526 3.1527 1.7412 0 3.1527-1.4115 3.1527-3.1527 0-1.7411-1.4115-3.1526-3.1527-3.1526Zm-6.2271.938a.6774.6774 0 1 0-1.3549 0v4.6378c0 .4029.3266.7295.7295.7295H6.283a.6774.6774 0 1 0 0-1.3549H4.355V12.538Zm13.5225.4168c-.9928 0-1.7978.8049-1.7978 1.7978 0 .9929.805 1.7978 1.7978 1.7978.6039 0 1.1391-.298 1.4653-.7555l-.792.0256a.6775.6775 0 0 1-.0438-1.3541l1.7402-.0563c.4456-.0145.8175.3789.7434.8428a3.1272 3.1272 0 0 1-.089.3932c-.3852 1.3054-1.5923 2.2592-3.0241 2.2592-1.7411 0-3.1526-1.4115-3.1526-3.1527 0-1.7411 1.4115-3.1526 3.1526-3.1526.7201 0 1.3856.2422 1.9166.6493a.6774.6774 0 0 1-.8242 1.0753 1.7873 1.7873 0 0 0-1.0924-.3698Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'LogsFilled'
);
